<!--  -->
<template>
  <div class="main">
    <div class="form-screen">
      <a-input-search
        placeholder="请输入广告位名称"
        style="width:240px"
        class="screen-option"
        enterButton
        @search="onSerch"
      ></a-input-search>
      <a-button type="primary" @click="editAdv('add')">添加广告位</a-button>
    </div>
    <a-table
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name }}
      </template>
      <template slot="source" slot-scope="source">
        <a-icon
          type="desktop"
          v-if="source == '1'"
          style="font-size:18px;color:#999"
        />
        <a-icon
          type="mobile"
          v-else-if="source == '2'"
          style="font-size:18px;color:#999;"
        />
      </template>

      <template slot="size" slot-scope="record">
        <span v-if="record.source == '1'"
          >{{ record.width }}*{{ record.height }}</span
        >
        <span v-else-if="record.source == '2'">自适应</span>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-button type="primary editable-add-btn" @click="getCode(record)">
          获取代码
        </a-button>
        <a-button
          :style="{ marginLeft: '8px' }"
          type="primary editable-add-btn"
          @click="editAdv('edit', record)"
        >
          <a-icon type="edit" />编辑
        </a-button>

        <a-popconfirm
          title="删除广告位,对应的投放管理也会被删除，确定删除么"
          okText="确定"
          cancelText="取消"
          @confirm="del(record.id)"
        >
          <a-icon slot="icon" type="warning" style="color: red" />
          <a-button type="danger" :style="{ marginLeft: '8px' }">
            <a-icon type="delete" />删除
          </a-button>
        </a-popconfirm>
      </template>
    </a-table>
    <a-drawer
      :title="drawerTitle"
      placement="right"
      :closable="true"
      @close="materielVisible = false"
      :visible="materielVisible"
      :width="800"
      :destroyOnClose="true"
    >
      <a-row>
        <a-col :span="20">
          <a-form :form="form" layout="vertical" @submit="complete">
            <div style="min-height:750px;">
              <a-form-item label="广告位名称：">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          max: 100,
                          message: '广告位,且不超过100个字'
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                  placeholder="请输入广告位名称"
                />
              </a-form-item>
              <a-form-item label="id" style="display:none">
                <a-input v-decorator="['id']" />
              </a-form-item>
              <label for="" style="margin-bottom:10px;" v-show="sizeNick"
                >广告位尺寸：</label
              >
              <a-row v-show="sizeNick">
                <a-col :span="12">
                  <a-form-item
                    label="宽度："
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 10 }"
                  >
                    <a-input
                      size="small"
                      v-decorator="[
                        'width',
                        {
                          rules: [
                            {
                              required: true,
                              message: '图片宽度必填'
                            },
                            {
                              validator: imageSize
                            }
                          ],
                          initialValue: 300
                        }
                      ]"
                      style="width: 80px"
                    />
                    px
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item
                    label="高度："
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 10 }"
                  >
                    <a-input
                      size="small"
                      v-decorator="[
                        'height',
                        {
                          rules: [
                            { required: true, message: '图片高度必填' },
                            {
                              validator: imageSize
                            }
                          ],
                          initialValue: 40
                        }
                      ]"
                      style="width: 80px"
                    />
                    px
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item label="投放类型：">
                <a-radio-group
                  @change="sourceKey"
                  v-decorator="[
                    'source',
                    {
                      rules: [
                        {
                          required: true
                        }
                      ],
                      initialValue: '1'
                    }
                  ]"
                >
                  <a-radio :value="'1'">PC端</a-radio>
                  <a-radio :value="'2'">移动端</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>

            <a-form-item>
              <a-button type="primary" html-type="submit">
                完成
              </a-button>
              <a-button
                :style="{ marginLeft: '8px' }"
                @click="materielVisible = false"
              >
                取消
              </a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-drawer>
    <a-modal
      title="获取代码"
      :visible="visible"
      width="800px"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="visible = false"
    >
      <div style="padding:10px;">
        <section class="slot-get-code-title">
          <strong>&lt;head&gt;代码</strong>
        </section>
        <section class="slot-get-code-content">
          <a-textarea :rows="2" v-model="headCode" id="hAll" @focus="hAllEle" />
        </section>
        <section class="slot-get-code-title-bottom">
          <strong>&lt;/head&gt;</strong>
        </section>
        <section class="slot-get-code-title">
          <p><strong>&lt;body&gt;代码：</strong>请粘贴到广告位所在位置</p>
          <p></p>
        </section>
        <section class="slot-get-code-content">
          <a-textarea :rows="10" v-model="code" @focus="allEle" id="all" />
        </section>
        <section class="slot-get-code-title-bottom">
          <strong>&lt;/body&gt;</strong>
        </section>
        <div style="text-align: right">
          <a-button @click="visible = false">返回</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
const columns = [
  {
    title: '广告位名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '尺寸',
    scopedSlots: { customRender: 'size' },
    align: 'center',
    width: '20%'
  },
  {
    title: '投放类型',
    scopedSlots: { customRender: 'source' },
    dataIndex: 'source',
    align: 'center',
    width: '20%'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    with: 400
  }
];

export default {
  directives: { infiniteScroll },
  components: {},
  data() {
    return {
      drawerTitle: '广告物料',
      data: [], //表格数据
      pagination: {},
      loading: true,
      columns,
      visible: false,
      materielVisible: false, //编辑物料开关
      previewVisible: false, //预览modal
      form: this.$form.createForm(this),
      // preview: {
      //   width: 300,
      //   height: 40
      // },
      limit: 10,
      code: '',
      headCode: '',
      sizeNick: true
    };
  },

  computed: {},

  watch: {},

  methods: {
    //判断图片尺寸是否为number
    imageSize(rule, value, callback) {
      let reg = /^[0-9]+(.[0-9]{2})?$/;
      if (!reg.test(value)) {
        callback('请输入最多两位小数的正数');
      } else {
        callback();
      }
    },
    //广告位列表
    fetch(params = {}) {
      this.$http.post('/api/ad/positionlist', params).then(res => {
        const pagination = { ...this.pagination };
        if (res.data.state == 200) {
          // pagination.total = data.totalCount;
          pagination.total = 10 * res.data.pages;
          this.loading = false;
          this.data = res.data.data;
        } else {
          this.loading = false;
          pagination.total = 0;
          this.data = [];
        }
        this.pagination = pagination;
      });
    },

    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.loading = true;
      this.fetch({
        limit: this.limit,
        page: pagination.current
      });
    },
    //搜索物料
    onSerch(value, event) {
      this.fetch({
        limit: this.limit,
        name: value
      });
    },
    //编辑广告
    editAdv(type, record) {
      this.materielVisible = true;
      if (type === 'edit') {
        this.$nextTick(function() {
          this.form.setFieldsValue({
            id: record.id ? record.id : '',
            name: record.name,
            width: record.width,
            height: record.height,
            source: record.source
          });
          this.drawerTitle = '编辑广告物料';
          if (record.source == '2') {
            this.sizeNick = false;
          } else if (record.source == '1') {
            this.sizeNick = true;
          }
        });
      } else {
        // this.preview.width = 300;
        // this.preview.height = 40;
        this.drawerTitle = '新建广告物料';
        this.sizeNick = true;
      }
    },

    //上传物料
    complete(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            id: values.id ? values.id : '',
            name: values.name,
            width: values.width,
            height: values.height,
            source: values.source
          };
          this.$http.post('/api/ad/positionupdate', params).then(res => {
            if (res.data.state == 200) {
              if (params.id == '') {
                this.$message.success('添加成功');
              } else {
                this.$message.success('编辑成功');
              }
              this.fetch({ limit: this.limit });
              this.materielVisible = false;
            } else {
              this.$message.error('操作失败，请重试');
            }
          });
        }
      });
    },
    //删除广告位
    del(id) {
      this.$http
        .post('/api/ad/positiondel', {
          ids: id
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('删除成功');
            this.fetch({ limit: this.limit });
          } else {
            this.$message.error('操作失败，请重试');
          }
        });
    },
    //获取代码
    getCode(record) {
      this.visible = true;
      this.code = '';
      this.headCode = '';
      let siteid = 0;
      if (
        window.localStorage.getItem('siteinfo') != null &&
        window.localStorage.getItem('siteinfo') != ''
      ) {
        let setSiteInfo = JSON.parse(window.localStorage.getItem('siteinfo'));
        siteid = setSiteInfo.site_id;
      }
      this.headCode += '<!-- 请置于所有广告位代码之前 -->\n';
      this.headCode +=
        '<script src="//cdn.ycrmt.cn/js/advertisement.js"></' + 'script>';
      this.code += '<!-- 广告位：' + record.name + ' -->\n';
      this.code += '<script>\n';
      this.code += '  (function() {\n';
      this.code += '    var s ="_" +Math.random().toString(36) .slice(2);\n';
      this.code += "    document.write('<div id='" + '+s+' + "'></div>');\n";
      this.code +=
        '    var h = new window.generate(' +
        siteid +
        ',' +
        record.id +
        ',s);\n';
      this.code += '    h.create();\n';
      this.code += '  })();\n';
      this.code += '</' + 'script>';
    },
    allEle() {
      document.getElementById('all').select();
    },
    hAllEle() {
      document.getElementById('hAll').select();
    },
    //切换投放类型
    sourceKey(e) {
      let value = e.target.value;
      if (value == '2') {
        this.sizeNick = false;
      } else if (value == '1') {
        this.sizeNick = true;
      }
    }
  },
  created() {},
  mounted() {
    this.fetch({ limit: this.limit });
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.screen-option {
  margin-right: 10px;
  margin-bottom: 10px;
}
.ant-form-item {
  margin-bottom: 8px;
}

.picture-list {
  height: 600px;
  /*min-height: 600px;*/
  overflow-y: auto;
}

.picture-list .lists {
  margin: 0 10px;
}
.picture-list .lists ul li {
  float: left;
  width: 205px;
  height: 175px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 10px;
}
.picture-list .lists ul li.pic-lists:hover {
  background-color: #f2f6fc;
}
.picture-list .lists .imgs {
  height: 145px;
  line-height: 145px;
}
.picture-list .lists .title {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*height:28px;*/
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.picture-list .lists ul li:hover .title {
  color: #409eff;
}
.picture-list .lists ul li img {
  vertical-align: middle;
  max-width: 145px;
  max-height: 145px;
  border-radius: 5px;
}
.preview-box {
  position: absolute;
  width: 352px;
  height: 302px;
  padding: 25px;
  border: 1px solid #ddd;
  right: 185px;
  overflow: hidden;
}
.slot-get-code-title strong,
.slot-get-code-title-bottom strong {
  color: #000;
  font-size: 14px;
  padding-left: 10px;
  font-weight: bold;
}
.slot-get-code-content {
  padding: 5px;
  position: relative;
}
.slot-get-code-title-bottom {
  margin-bottom: 30px;
}
</style>
